<p-menu #menu [model]="items" [popup]="true" [styleClass]="'text-sm'"></p-menu>

@if (report) {
  <!-- visualizar -->
  <app-modal [header]="'Visualizar Denúncia'" [style]="'w-full max-w-lg'"
    [isShow]="showComplaintModal" (cancel)="showComplaintModal = false;">
    <div><p>{{report.report}}</p></div>
  </app-modal>
}
